import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Highcharts from 'highcharts/highstock';
import ChartOptions from './ChartOptions';

export default class Chart extends Component {
  /*
    This component is a wrapper for different charts (highcharts).
  */

  constructor(props) {
    super(props);
    this.chart = undefined;
  }

  // When the DOM is ready, create the chart.
  componentDidMount() {
    // Extend Highcharts with modules
    if (this.props.modules) {
      this.props.modules.forEach(module => {
        module(Highcharts);
      });
    }

    // Get options for the chart to be rendered
    const options = ChartOptions.getOptions(this);
    this.chart = new Highcharts[this.props.type || 'Chart'](
      this.props.container,
      options
    );
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    const options = ChartOptions.getOptions({ props: newProps });
    this.chart.update(options, true);
  }

  // Destroy chart before unmount.
  componentWillUnmount() {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  render() {
    return <div id={this.props.container} className={this.props.className} />;
  }
}

Chart.propTypes = {
  modules: PropTypes.arrayOf(PropTypes.func),
  type: PropTypes.string,
  container: PropTypes.string.isRequired,
  className: PropTypes.string
};
